import { MediasCarousel } from "components/Carousel"
import NoImagePlaceholder from "components/NoImagePlaceholder/NoImagePlaceholder.png"
import * as MediaType from "enums/MediaType"

export function BoatImages(props) {
  const { boat } = props
  const albumImages = boat.album
    ? boat.album.medias.filter(
        (media) => media.type.enum_value === MediaType.PHOTO,
      )
    : []

  const allImages = [
    boat.imageFile
      ? {
          type: { enum_value: MediaType.PHOTO },
          imageFile: boat.imageFile,
        }
      : null,
    ...albumImages,
  ].filter(Boolean)

  const medias = allImages.map((media) => ({
    ...media,
    alt: boat?.brandNormalized + " " + boat?.modelNormalized,
  }))

  if (allImages.length === 0) {
    return <img src={NoImagePlaceholder} alt="" loading={"lazy"} />
  }

  return (
    <MediasCarousel
      medias={medias}
      getMediaUrl={(media) => (media.thumbs ? media.thumbs.w800 : media.url)}
    />
  )
}
